module.exports = __webpack_public_path__ + "img/tn-timeline-misc-7.2db8e814.jpg";